import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import palceholderimage from "../../../assets/images/palceholderimage.webp";
import NeverWorn from "../../../assets/images/HomePage/never_worn.webp";
import NewIn from "../../../assets/images/HomePage/new_in.webp";
import PriceDrops from "../../../assets/images/HomePage/price_drops.webp";
import Vintage from "../../../assets/images/HomePage/vintage_2.webp";
import { useDispatch } from "react-redux";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  SetBottomSizeFilter,
  resetLoadingNumber,
  getAllProductOnline,
} from "../../../features/Products/ProductSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";
import handbag from "../../../assets/images/HomePage/trust-handbag.svg";
import loan from "../../../assets/images/HomePage/trust-loan.png";
import customer from "../../../assets/images/HomePage/trust-customer-services.svg";
import trust from "../../../assets/images/HomePage/trust-trust.svg";

function TrustSection() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageLoaded, setImageLoaded] = useState(false);

  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }

  return (
    <>
      <div className="trust-banner">
        <div className="trust-maintitle-banner">{t("TrustMainTitle")}</div>
        <div
          className={`trust-banner pb-md-5  row ${
            i18n.language == "en" ? "ms-0 me-0 " : `me-0 ms-0`
          }`}
          id="style-2"
        >
          <div
            className="col-md-3 col-12 d-flex  justify-content-center align-items-center mx-0 "
            id="style-2"
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "100%", height: "5vw", minHeight: "60px" }}
            >
              <div className="text-center pt-2 px-4">
                <img
                  className="pb-4 trust-image-banner"
                  src={handbag}
                  alt="main"
                />

                <p>{t("TrustTitle1")}</p>
                <p className="trust-subtitle-banner">{t("TrustSubTitle1")}</p>
              </div>
            </div>
          </div>
          <div
            className="col-md-3 col-12 d-flex  justify-content-center align-items-center mx-0 "
            id="style-2"
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "100%", height: "5vw", minHeight: "60px" }}
            >
              <div className="text-center pt-2 px-4">
                <img
                  className="pb-4 trust-image-banner"
                  src={loan}
                  alt="main"
                />
                <p>{t("TrustTitle2")}</p>
                <p className="trust-subtitle-banner">{t("TrustSubTitle2")}</p>
              </div>
            </div>
          </div>
          <div
            className="col-md-3 col-12 d-flex  justify-content-center align-items-center mx-0 "
            id="style-2"
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "100%", height: "5vw", minHeight: "60px" }}
            >
              <div className="text-center pt-2 px-4">
                <img
                  className="pb-4 trust-image-banner"
                  src={trust}
                  alt="main"
                />
                <p>{t("TrustTitle3")}</p>
                <p className="trust-subtitle-banner">{t("TrustSubTitle3")}</p>
              </div>
            </div>
          </div>
          <div
            className="col-md-3 col-12 d-flex  justify-content-center align-items-center mx-0 "
            id="style-2"
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "100%", height: "5vw", minHeight: "60px" }}
            >
              <div className="text-center pt-2 px-4">
                <img
                  className="pb-4 trust-image-banner"
                  src={customer}
                  alt="main"
                />
                <p>{t("TrustTitle4")}</p>
                <p className="trust-subtitle-banner">{t("TrustSubTitle4")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br></br>
      {/* <div className="pb-md-5 text-center  pb-lg-5 pt-md-5 pb-md-5" >
    <button
          className="btn-shop buttonH mb-lg-5"
          onClick={() =>
            dispatch(getAllProductOnline([])) &
            dispatch(SetSearch("")) &
            dispatch(SetSelectdPage(0)) &
            dispatch(SetSizeFilter([])) &
            dispatch(SetBottomSizeFilter([]))&
            dispatch(SetTopSizeFilter([])) &
            dispatch(resetLoadingNumber(30))&
            navigate(`/products`) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          aria-label="Shop All Products"
          
        >
         {t( "SHOP ALL")}
        </button>

    </div> */}
      {/* <div className="text-center pt-lg-5 pt-4 pb-lg-5  pb-5 ">
    
        <button
          className="btn-shop buttonH mb-lg-5"
          onClick={() =>
            dispatch(SetSelectdPage(0)) &
            navigate(`/products`) &
            window.scrollTo({ top: 0, left: 0, behavior: "instant" })
          }
          aria-label="View All Products"
        >
         {t( "SHOP ALL")}
        </button>
      </div> */}
    </>
  );
}

export default TrustSection;
